<p-table [columns]="kitHeaders" [value]="masterLists" selectionMode="single" [(selection)]="selectedMasterList"
  (onRowSelect)="onRowSelect($event)">
  <ng-template pTemplate="caption">
    {{title}}
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th id="{{kitField.field+'Column'}}" *ngFor="let kitField of columns"
        [pSortableColumn]="kitField.field==isLab ? kitField.sort:kitField.field">
        {{kitField.header}}
        <p-sortIcon [field]="kitField.field==isLab ? kitField.sort:kitField.field"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr [pSelectableRow]="rowData">
      <ng-container *ngFor="let kitCol of columns">
        <td *ngIf="kitCol.field!=isActive && kitCol.field!=isLab" class="wrapword">
          {{rowData[kitCol.field]}}
        </td>
        <td *ngIf="kitCol.field == isActive">
          <p-checkbox id="active" disabled [(ngModel)]="rowData[kitCol.field]" binary="true"></p-checkbox>
        </td>
        <td *ngIf="kitCol.field==isLab">
          {{rowData[kitCol.field]!= null? rowData[kitCol.field].name :''}}
        </td>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="summary" let-rowData>
    <div style="text-align:left">
      <button type="button" style="height: 35px;" pButton icon="pi pi-plus" (click)="showDialogToAddMasterList()" label="Add"></button>
    </div>
  </ng-template>
</p-table>

<p-dialog header="{{title}} Details" [(visible)]="displayMasterListDialog" [focusOnShow]="false" showEffect="fade"
  [modal]="true" [style.width]="'800px'" position="top" (onHide)="clearCache()" baseZIndex="10">
  <div *ngIf="masterList">
    <div *ngFor="let kitField of detailCols">
      <div class="form-group m-2">
        <div>
          <label>{{kitField.header}}</label>
        </div>
        <div *ngIf="kitField.field == isKitsName">
          <input pInputText class="form-control" [(ngModel)]="masterList[kitField.field]"
            (change)="masterList[kitField.field]=masterList[kitField.field].trim()">
        </div>
        <div *ngIf="kitField.field == isLab">
          <p-dropdown [options]="this.labOptions" [(ngModel)]="selectedLab" [filter]="true" placeholder="Select a Lab"
            optionLabel="name" [showClear]="true" (onChange)="onLabSelect()"></p-dropdown>
        </div>

        <div *ngIf="kitField.field == isKitType">
          <p-dropdown [options]="kitType" [(ngModel)]="masterList.kitType" [filter]="true" placeholder="Select a Kit"
            [showClear]="true"></p-dropdown>
        </div>
        <div *ngIf="kitField.field == isRequiredMaterials">
          <input pInputText class="form-control" [(ngModel)]="masterList[kitField.field]"
            (change)="masterList[kitField.field]=masterList[kitField.field].trim()">
          <div>(Comma seperated values expected)</div>
        </div>
        <div *ngIf="kitField.field == isrequiredMaterialsExt">
          <input pInputText class="form-control" [(ngModel)]="masterList[kitField.field]"
            (change)="masterList[kitField.field]=masterList[kitField.field].trim()">
          <div>(Comma seperated values expected)</div>
        </div>
        <div *ngIf="kitField.field == iskitResults">
          <input pInputText class="form-control" [(ngModel)]="this.kitResultsString">
          <div>(Comma seperated values expected)</div>
        </div>
        <div *ngIf="kitField.field == isSwabRestriction" class="ui-inputgroup" id="inputClass">

          <p-multiSelect [options]="swabTypeList" [(ngModel)]="masterList.swabRestriction" id="multiselectStatuses"
            [style]="{'width':'10vw'}">
            <ng-template let-item pTemplate="selectedItem">
              <span style="vertical-align:middle">{{item.label}}</span>
            </ng-template>
            <ng-template let-status pTemplate="item">
              {{status.label}}
            </ng-template>
          </p-multiSelect>

        </div>

        <div *ngIf="kitField.field == isRedoReason" class="ui-inputgroup" id="inputClass">
          <p-multiSelect [options]="redoReasonsList" [(ngModel)]="selectedRedoReason" [filter]="true"
            placeholder="Select Redo Reason" [style]="{'width':'20vw'}" optionLabel="reasonName">
          </p-multiSelect>
        </div>


        <div *ngIf="kitField.field == isChannel1Gene">
          <input pInputText class="form-control" [(ngModel)]="masterList[kitField.field]"
            (change)="populateDominantChannel()">
        </div>
        <div *ngIf="kitField.field == isChannel1File">
          <input pInputText class="form-control" [(ngModel)]="masterList[kitField.field]"
            (change)="masterList[kitField.field]=masterList[kitField.field].trim()">
        </div>
        <div *ngIf="kitField.field == isChannel1Dye">
          <input pInputText class="form-control" [(ngModel)]="masterList[kitField.field]"
            (change)="masterList[kitField.field]=masterList[kitField.field].trim()">
        </div>
        <div *ngIf="kitField.field == isChannel2Gene">
          <input pInputText class="form-control" [(ngModel)]="masterList[kitField.field]"
            (change)="populateDominantChannel()">
        </div>
        <div *ngIf="kitField.field == isChannel2File">
          <input pInputText class="form-control" [(ngModel)]="masterList[kitField.field]"
            (change)="masterList[kitField.field]=masterList[kitField.field].trim()">
        </div>
        <div *ngIf="kitField.field == isChannel2Dye">
          <input pInputText class="form-control" [(ngModel)]="masterList[kitField.field]"
            (change)="masterList[kitField.field]=masterList[kitField.field].trim()">
        </div>
        <div *ngIf="kitField.field == isChannel3Gene">
          <input pInputText class="form-control" [(ngModel)]="masterList[kitField.field]"
            (change)="populateDominantChannel()">
        </div>
        <div *ngIf="kitField.field == isChannel3File">
          <input pInputText class="form-control" [(ngModel)]="masterList[kitField.field]"
            (change)="masterList[kitField.field]=masterList[kitField.field].trim()">
        </div>
        <div *ngIf="kitField.field == isChannel3Dye">
          <input pInputText class="form-control" [(ngModel)]="masterList[kitField.field]"
            (change)="masterList[kitField.field]=masterList[kitField.field].trim()">
        </div>
        <div *ngIf="kitField.field == isChannel4Gene">
          <input pInputText class="form-control" [(ngModel)]="masterList[kitField.field]"
            (change)="populateDominantChannel()">
        </div>

        <div *ngIf="kitField.field == isChannel4File">
          <input pInputText class="form-control" [(ngModel)]="masterList[kitField.field]"
            (change)="masterList[kitField.field]=masterList[kitField.field].trim()">
        </div>
        <div *ngIf="kitField.field == isChannel4Dye">
          <input pInputText class="form-control" [(ngModel)]="masterList[kitField.field]"
            (change)="masterList[kitField.field]=masterList[kitField.field].trim()">
        </div>


        <div *ngIf="kitField.field == isChannel5Gene">
          <input pInputText class="form-control" [(ngModel)]="masterList[kitField.field]"
            (change)="populateDominantChannel()">
        </div>
        <div *ngIf="kitField.field == isChannel5File">
          <input pInputText class="form-control" [(ngModel)]="masterList[kitField.field]"
            (change)="masterList[kitField.field]=masterList[kitField.field].trim()">
        </div>
        <div *ngIf="kitField.field == isChannel5Dye">
          <input pInputText class="form-control" [(ngModel)]="masterList[kitField.field]"
            (change)="masterList[kitField.field]=masterList[kitField.field].trim()">
        </div>
        <div *ngIf="kitField.field == 'runProtocol'">
          <input pInputText class="form-control" [(ngModel)]="masterList[kitField.field]"
            (change)="masterList[kitField.field]=masterList[kitField.field].trim()">
        </div>
        <div *ngIf="kitField.field == 'thermalProfile'">
          <textarea class="form-control" [(ngModel)]="masterList[kitField.field]" type="text"
            (change)="masterList[kitField.field]=masterList[kitField.field].trim()" rows="6"></textarea>
        </div>
        <div *ngIf="kitField.field == isDominantChannel">
          <p-dropdown [options]="dominantChannelList" [(ngModel)]="masterList[kitField.field]" [style]="{'width':'30%'}"
            placeholder="Select Dominant Channel">
          </p-dropdown>
        </div>

        <div *ngIf="kitField.field == 'machineType'">
          <p-dropdown [options]="machineTypeList" [(ngModel)]="selectedMachineType" [style]="{'width':'30%'}"
            placeholder="Select Machine Type" (onChange)="getsubTypesForMachineType()">
          </p-dropdown>
        </div>
        <div *ngIf="kitField.field == isKitImage">
          <input pInputText class="form-control" style="width: 44%;" name="profile" type="file"
            accept=".jpg,.jpeg,.gif,.png" (change)="onFileSelect($event)" id="fileChooser" placeholder="Upload File"
            #kitImageInput />
        </div>
        <div *ngIf="kitField.field == isselectedImage && masterList[kitField.field]!=''">
          <input pInputText class="form-control" style="width: 44%;" [(ngModel)]="masterList[kitField.field]"
            [disabled]="true">
        </div>
        <div *ngIf="kitField.field == isProcessingTime && mapOfProcessingTime">
          <table aria-describedby="Processing Time Table" class="text-center border border-secondary">
            <tbody>
              <tr>
                <th scope="kitField" class="border border-secondary" style="width: 10rem;">Machine Subtype</th>
                <th scope="kitField" class="border border-secondary" style="width: 10rem;">Processing Time</th>
              </tr>
              <tr *ngFor="let subType of subTypes">
                <td>{{subType}}</td>
                <td><p-spinner size="3" [min]="0" [ngModel]="mapOfProcessingTime.get(subType)"
                    (ngModelChange)="setProcessingTime(subType,$event)"></p-spinner></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div *ngIf="kitField.field == isPureAnalysis">
          <p-checkbox id="pureAnalysis" [(ngModel)]="pureAnalysisKit" binary="true"></p-checkbox>
        </div>
        <div *ngIf="kitField.field == isActive">
          <p-checkbox id="active" [(ngModel)]="masterList[kitField.field]" binary="true"></p-checkbox>
        </div>
      </div>
    </div>
  </div>
  <div class="ui-dialog-buttonpane ui-helper-clearfix">
    <button type="button" pButton icon="pi pi-check" [disabled]="isSaveDisabled()" (click)="saveMasterList()"
      label="Save" style="float: right; height: 36px;"></button>
  </div>
</p-dialog>